export default "__VITE_ASSET__BLVjBlgD__"